<svelte:head>

    <link rel="stylesheet" type="text/css" href="/global.css" />
    <link rel="stylesheet" type="text/css" href="/css/forms.css" />

</svelte:head>

<script>

    import { onMount } from "svelte";
    import { createEventDispatcher } from "svelte";

    import {
        errorReasons,
        listProperties
    } from "../../api.svelte";


    const INTEGRATION_ICONS_PATH = '/images/icons/integrations/';


    const dispatch = createEventDispatcher();

    export let properties;
    export let numAvailable;
    export let showFormtitle = true;


    const onPreviewClicked = (propertyId) => {

        dispatch('preview', {
            propertyid: propertyId
        });

    };

    const onCreateClicked = () => {

        dispatch('create', {});
    };

    $: getNumProperties = () => {

        if (!properties) return 0;

        return Object.keys(properties).length;

    };

    $: getNumAvailable = () => {

        if (!properties) return 0;

        return getNumProperties() + numAvailable;

    };

</script>


<form on:submit|preventDefault={() => null} id="propertieslistform" class="forms">

    {#if showFormtitle}

        <div id="formtitle">

            Ihre Standorte ({getNumProperties()} / {getNumAvailable()})

        </div>

    {/if}

    {#if properties}

        <div class="properties">

            {#each Object.entries(properties) as [propertyId, property]}

                <div
                        class="property-preview"
                        on:click={() => onPreviewClicked(propertyId)} >

                    <div class="preview-meta">

                        <span class="preview-name">{property['details']['name']}</span>
                        <span class="preview-address">{property['details']['address']}</span>

                    </div>

                    <div class="preview-icons">

                        {#each Object.entries(property['integrations']) as [integrationKey, integration]}

                            {#if Object.keys(integration).includes('name')}

                                <img src="{INTEGRATION_ICONS_PATH + integrationKey}.svg" />

                            {/if}

                        {/each}

                    </div>

                </div>

            {/each}

            {#if numAvailable > 0}

                <div
                        class="property-preview property-create"
                        on:click={() => onCreateClicked()}>

                    <img src="/images/icons/arrow-default.svg" />
                    <span>Neuen Standort hinzufügen</span>

                </div>

            {/if}

        </div>

    {/if}

</form>


<style>

    #formtitle {
        margin-bottom: 4.44vh;
        font-family: 'Raleway', sans-serif;
        font-size: 1.85vh;
        font-weight: 500;
    }

    .property-preview {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 30vh;
        padding: 1.3vh 1.64vh;
        margin-bottom: 1.2vh;
        border-radius: 1vh;
        cursor: pointer;
        background-color: #FFFFFF;
        -webkit-box-shadow: 0px 5px 20px 0px rgba(73, 119, 172, 0.15);
        -moz-box-shadow: 0px 5px 20px 0px rgba(73, 119, 172, 0.15);
        box-shadow: 0px 5px 20px 0px rgba(73, 119, 172, 0.15);
    }

    .property-preview:last-child {
        margin-bottom: 0;
    }

    .property-preview.property-create {
        justify-content: flex-start;
        padding: 2vh 1.64vh;
    }

    .property-create span {
        margin-left: 1vh;
        font-family: 'Raleway', sans-serif;
        font-weight: 400;
        font-size: 1.38vh;
    }

    .preview-meta {
        display: flex;
        flex-direction: column;
        text-align: left;
        font-family: 'Raleway', sans-serif;
    }

    .preview-name {
        margin-bottom: 0.55vh;
        font-weight: 500;
        font-size: 1.38vh;
    }

    .preview-address {
        font-weight: 400;
        font-size: 1.25vh;
    }

    .preview-icons {
        display: flex;
    }

    .preview-icons img {
        margin-right: 0.5vh;
    }

    .preview-icons img:last-child {
        margin-right: 0;
    }

</style>
